import React, { useContext, useEffect, useState } from 'react'

import { Dialog } from 'primereact/dialog'
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { getComentarios, getParticipaciones, getPreguntasEncuesta, getPreguntasEncuestaArea } from '../../../../API/Gerencia/Encuestas/EncuestasRequests';
import Card from '../../../../Base/Components/Card/Card';

import CardPregunta from './CardPregunta';
import { Button } from 'primereact/button';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import { TabPanel, TabView } from 'primereact/tabview';

const PreguntasEncuestaList = ({ encuestaShow, setEncuestaShow }) => {

    const [data, setdata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [Preguntas, setPreguntas] = useState([]);
    const [participaciones, setParticipaciones] = useState([]);
    const [dataArea, setdataArea] = useState([]);
    const [comentarios, setComentarios] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    const { userAuth } = useContext(AuthContext);

    const opciones = [
        {
            id: 1,
            name: 'Totalmente en desacuerdo',
            value: 1
        },
        {
            id: 2,
            name: 'En desacuerdo',
            value: 2
        },
        // {
        //     id: 3,
        //     name: 'Ni de acuerdo ni en desacuerdo',
        //     value: 3
        // },
        {
            id: 4,
            name: 'De acuerdo',
            value: 4
        },
        {
            id: 5,
            name: 'Totalmente de acuerdo',
            value: 5
        }
    ]


    const getInfo = async () => {   
        
        if(activeIndex === 3){
            setLoading(true);
            const participacionesTempo = await getParticipaciones(encuestaShow?.IdEncuesta);
            setParticipaciones(participacionesTempo);
            setLoading(false);
        }else if(activeIndex === 1){

            setLoading(true);
            const areas = await getPreguntasEncuestaArea(encuestaShow?.IdEncuesta);
            let a = [];
            if(areas?.length > 0){
                areas.forEach((item) => {
                    item.Preguntas.forEach((pregunta) => {
                        a.push({
                            ...pregunta,
                            IdEncuesta: item.IdEncuesta,
                            IdPreguntaGrupo: item.IdPreguntaGrupo,
                            TituloGroup: item?.Titulo,
                            valorPromedio: opciones.find((op) => op.value === pregunta.MaxValueInt)?.name,
                            valor1: pregunta.Respuestas.filter((r) => r.ValueInt === 1).length,
                            valor2: pregunta.Respuestas.filter((r) => r.ValueInt === 2).length,
                            valor3: pregunta.Respuestas.filter((r) => r.ValueInt === 3).length,
                            valor4: pregunta.Respuestas.filter((r) => r.ValueInt === 4).length,
                            valor5: pregunta.Respuestas.filter((r) => r.ValueInt === 5).length,
                        });
                    }
                    )
                })
                setdataArea(a);
            }
            setLoading(false);
            
        }else if(activeIndex === 4){
            setLoading(true)
            const resp = await getComentarios()
            setComentarios(resp)
            setLoading(false)
        }else{
            setLoading(true);
            const t = await getPreguntasEncuesta(encuestaShow?.IdEncuesta);
            let p = [];
            if(t.length === 0){
                setLoading(false);
                return;
            }else{
                t.forEach((item) => {
                    item.Preguntas.forEach((pregunta) => {
                        p.push({
                            ...pregunta,
                            IdEncuesta: item.IdEncuesta,
                            IdPreguntaGrupo: item.IdPreguntaGrupo,
                            TituloGroup: item?.Titulo,
                            valorPromedio: opciones.find((op) => op.value === pregunta.MaxValueInt)?.name,
                            valor1: pregunta.Respuestas.filter((r) => r.ValueInt === 1).length,
                            valor2: pregunta.Respuestas.filter((r) => r.ValueInt === 2).length,
                            valor3: pregunta.Respuestas.filter((r) => r.ValueInt === 3).length,
                            valor4: pregunta.Respuestas.filter((r) => r.ValueInt === 4).length,
                            valor5: pregunta.Respuestas.filter((r) => r.ValueInt === 5).length,
                        });
                    }
                    )
                })
    
                setPreguntas(p);
                setdata(t);
            }
            setLoading(false);
        }
    }

    const columns = [
        {
            header: 'IdPregunta',
            handerEn: '',
            field: 'IdPregunta',
            className: 'XXsmall',

        },
        {
            header: 'TituloGroup',
            handerEn: '',
            field: 'TituloGroup',
            className: 'XXXlarge',
            frozen: true,
            // rowGroup: true,
            // hidden: false
        },
        {
            header: 'Pregunta',
            handerEn: '',
            field: 'Pregunta',
            Sumary: 'count',
            className: 'XXXXlarge',
            frozen: true,
            Sumary: 'count'
        },
        {
            field: 'valorPromedio',
            header: 'Valor Promedio',
            headerEn: '',
            className: '',
            frozen: true,
            hidden: userAuth.IdRol === 1
        },
        {
            header: 'Promedio',
            field: 'MaxValueInt',
            className: 'XXsmall',
            hidden: userAuth.IdRol === 1
        },
        ...opciones.map((opcion) => {
            return {
                field: `valor${opcion.value}`,
                header: opcion.name,
                headerEn: '',
                className: '',
                Format: 'Center'
            }
        })
    ]

    const table = {
        Columns: columns,
        Data: Preguntas,
        loading: loading,
        selected: selected,
        setSelected: setSelected,
    }

    const columnsArea = [
        {
            header: 'IdPregunta',
            handerEn: '',
            field: 'IdPregunta',
            className: 'XXsmall',

        },
        {
            header: 'TituloGroup',
            handerEn: '',
            field: 'TituloGroup',
            className: 'XXXlarge',
            frozen: true,
            // rowGroup: true,
            // hidden: false
        },
        {
            field: 'Area',
            header: 'Seccion',
            headerEn: 'Section',
            className: 'Xlarge',
        },
        {
            header: 'Pregunta',
            handerEn: '',
            field: 'Pregunta',
            className: 'XXXXlarge',
            Sumary: 'count',
            frozen: true,
            Sumary: 'count'
        },
        {
            field: 'valorPromedio',
            header: 'Valor Promedio',
            headerEn: '',
            className: '',
            frozen: true,
            hidden: userAuth.IdRol === 1
        },
        {
            header: 'Promedio',
            field: 'MaxValueInt',
            className: 'XXsmall',
            hidden: userAuth.IdRol === 1
        },
        ...opciones.map((opcion) => {
            return {
                field: `valor${opcion.value}`,
                header: opcion.name,
                headerEn: '',
                className: '',
                Format: 'Center'
            }
        })
    ]

    const tableAreas = {
        Columns: columnsArea,
        Data: dataArea,
        loading: loading,
        selected: selected,
        setSelected: setSelected,
    }

    const columnsParticipaciones = [
        {
            header: 'ID',
            handerEn: 'ID',
            field: 'IdSeccion',
            className: 'Xsmall',
            hidden: userAuth?.IdRol === 1,
        },
        {
            header: 'Sección',
            handerEn: 'Section',
            field: 'Seccion',
            className: 'XXXlarge',
            flex: 1,
            Sumary: "count",
            minWidth: 500,
        },
        {
            header: 'Personal Activo',
            handerEn: 'Active Personnel',
            Format: 'Center',
            field: 'Activo',
            className: 'medium',
        },
        {
            header: 'Total',
            handerEn: 'Total',
            // Format: 'Center',
            field: 'Total',
            Format: 'Modal',
            className: 'medium',
            Sumary: 'sum'
        },
    ]

    const tableParticipacines = {
        Columns: columnsParticipaciones,
        Data: participaciones,
        loading: loading,
        selected: selected,
        setSelected: setSelected,
    }

    const columnsComentarios = [
        {
            field: 'Seccion',
            header: 'Seccion',
            headerEn: '',
            className: '',
        },
        {
            header: 'Comentario',
            handerEn: 'Comment',
            field: 'ValueString',
            flex: 1,
            Sumary: 'count',
        },
    ]

    const tableComentarios = {
        Columns: columnsComentarios,
        Data: comentarios,
        loading: loading,
    }


    const onHide = () => {
        setShowDialog(false);
        setEncuestaShow(null);
    }

    useEffect(() => {
        if (encuestaShow) {
            getInfo();
            setShowDialog(true);
        }
    }, [encuestaShow, activeIndex])




    const CardPreguntaGroup = ({ item, i }) => {
        return (
            <div className='my-5' key={i}>
                <Card
                    //  titulo={<div>
                    //     <h5>{item.Titulo}</h5>
                    // </div>} 
                    style={{ background: '#f2f2f2' }}
                    contenido={
                        <div className='p-3'>
                            <h3 className='text-bold'>{i + 1} - {item.Titulo}</h3>
                            {item.Preguntas.map((pregunta, n) => <CardPregunta item={pregunta} n={n} />)}
                        </div>
                    }
                />
            </div>
        )
    }


    return (
        <div>
            <Dialog
                header={<div className=''>
                    <h3>Encuesta: {encuestaShow?.Titulo}
                        {/* recargar */}
                    </h3>
                    <div className='d-flex align-items-center'>
                        <h3 className='mx-3'>Participantes: {encuestaShow?.NumRespuestas} </h3>
                        <Button icon="pi pi-refresh" className="p-button-rounded p-button-secondary p-button-text" onClick={() => getInfo()} />

                    </div>
                </div>}
                visible={showDialog}
                style={{ width: '50vw' }}
                onHide={onHide}
                closeOnEscape={false}
                maximizeIcon maximized>

                <div>
                    <TabView
                        activeIndex={activeIndex}
                        onTabChange={(e) => setActiveIndex(e.index)}
                     >
                        <TabPanel header="Global">
                            <div style={{ height: '80vh' }}>
                                <AgGrid table={table} />
                            </div>
                        </TabPanel>
                        <TabPanel header="Area">
                            <div style={{ height: '80vh' }}>
                                <AgGrid table={tableAreas} />
                            </div>
                        </TabPanel>
                        <TabPanel header="Graficos">
                            <div  style={{ height: '80vh' }}>
                                {/* <h1>graficos</h1> */}
                                {data.map((item, i) => <CardPreguntaGroup item={item} i={i} />)}
                            </div>
                        </TabPanel>
                        <TabPanel header="Participaciones">
                            <div style={{ height: '80vh' }}>
                                <AgGrid table={tableParticipacines} />
                            </div>
                        </TabPanel>

                        <TabPanel header="Comentarios">
                            <div style={{ height: '80vh' }}>
                                <AgGrid table={tableComentarios} />
                            </div>
                        </TabPanel>
                    </TabView>
                </div>
            </Dialog>
        </div>
    )
}

export default PreguntasEncuestaList